import { Block } from 'slate';
import sortOrganizations from './sortOrganizations';
import getOrganizationNodes from '../../../../../../../../../store/constants/getOrganizationNodes';
import tag from './preTag';
import scrollToSlateNode from './scrollToSlateNode';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';

const getWeBlock = (preTag, updatedOrdinal, { type }, universityPlan) => {
  let data = {
    type,
    data: {
      Ordinal: updatedOrdinal,
      selectAll: 1,
    },
    nodes: getOrganizationNodes({ preTag, addSection: true, universityPlan }),
  };

  if (preTag === 'skill') {
    data = {
      ...data,
      data: {
        selectAll: 1,
      },
    };
  }

  return Block.create(data);
};

const handleInsertOrganization = (params) => {
  const { event, editor, currentOrdinal, currentOrganization, universityPlan } =
    params;

  event.preventDefault();

  const updatedOrdinal = currentOrdinal + 1;

  const preTag = tag[currentOrganization.type];

  const weBlock = getWeBlock(
    preTag,
    updatedOrdinal,
    currentOrganization,
    universityPlan,
  );

  /**
   * Editor needs a paragraph always to insert Work Experience custom node
   * because a work experience node would not accept a work experience
   * please refer the Work Experience schema for more details
   *
   * When dragging is introduced, we need to make sure a paragraph stays always at the beginning of the editor
   * or on top of every work experience block
   *
   * moveForward(n) // n > 1 // is not working with the current version
   * when shifting from block to block
   */

  const {
    value: { document: currentDocument },
  } = editor;
  const { key: currentDocumentKey } = currentDocument;

  const indexOfCurrentOrganization = currentDocument.nodes
    .toArray()
    .indexOf(currentOrganization);

  editor.insertNodeByKey(
    currentDocumentKey,
    indexOfCurrentOrganization + 1,
    weBlock,
  );

  const newlyAddedOrganization =
    editor.value.document.nodes.toArray()[indexOfCurrentOrganization + 1];

  /**
   * By default the native selection would drop at the last division
   * it sees in the content editable div, but we need to force it to move
   * back to the beginning of the node but ignoring the label
   */
  const {
    value: {
      document,
      // focusBlock: { key: focusBlockKey }
    },
  } = editor;

  // const workExperience = document.getParent(focusBlockKey);

  // scrollToSlateNode(workExperience); // scrolls to newly added card

  // const organizationDetails = workExperience.nodes.toArray()[0];
  // const [
  //   skillOrganization,
  //   organizationName
  // ] = organizationDetails.nodes.toArray();

  scrollToSlateNode(newlyAddedOrganization); // scrolls to newly added card

  if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
  if (preTag === 'skill') {
    editor.moveToStartOfNode(newlyAddedOrganization.nodes.toArray()[0]);
  } else {
    const organizationsDetails = newlyAddedOrganization.nodes.toArray()[0];
    const organizationsDetailsFirstFocusableNode =
      organizationsDetails && organizationsDetails.nodes.toArray()[1];
    editor.moveToStartOfNode(organizationsDetailsFirstFocusableNode);
  }

  /**
   * Sort organizations ordinals
   */
  sortOrganizations({
    editor,
    preTag,
    currentOrganization,
    updatedOrdinal,
  });

  /**
   * Set document data
   */
  const { data: documentData, key: documentKey } = document;
  const documentDataJSON = documentData.toJSON();
  const { selectAll, rolesCount } = documentDataJSON;
  editor.setNodeByKey(documentKey, {
    data: {
      ...documentDataJSON,
      selectAll: selectAll + 1,
      rolesCount: rolesCount + 1,
    },
  });
};

export default handleInsertOrganization;
